import React, { useContext } from 'react'
import { Handle } from 'react-flow-renderer';
import { NodesContext } from '../../provider/IvrContext';

const HangupNode = ({ data, id }) => {
    const { onRemove } = useContext(NodesContext)
    return (
        <div
            style={{
                width: "80px",
                border: "2px solid red",
                borderRadius: "50%",
                background: "#fff",
                position: "relative",
                display: "flex",
                padding: "5px",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                transition: "0.3s ease-in-out",
            }}
        >
            <Handle
                type="target"
                position="top"
                id="new-target-handle-hangup"
                style={{
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "red",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                }}
            />

            <span
                style={{
                    fontSize: "9px",
                    fontWeight: "bold",
                    color: "#333",
                    textAlign: "center",
                    textTransform: "capitalize",
                }}
            >
                {data.label}
            </span>

            {/* Icons Row */}
            <div style={{ display: "flex", gap: "8px" }}>
                <i
                    className="fa fa-trash"
                    style={{ color: "red", fontSize: "12px", cursor: "pointer" }}
                    title="Remove"
                    onClick={() => onRemove(id)}
                />
            </div>
        </div>
    );
}

export default HangupNode